/**
 * Cuban convertible peso.
 */
export var CUC = {
  code: 'CUC',
  base: 10,
  exponent: 2
};